import { useContext } from 'react';
import { UserContext } from '../providers/UserProvider';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(UserContext);